import { useState, useRef } from "react";
import { debounce } from "lodash";
import toast from "react-hot-toast";
import useGet from "../read/useGet";
import usePut from "../put/usePut";

export const usePettyCashCurrencies = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedCurrencyId, setSelectedCurrencyId] = useState(null);

  const initialFilters = {
    limit: 10,
    page_number: 0,
    search_query: "",
  };

  const {
    list: currencyList,
    paramsObject: filters,
    setGetListParams: setFilters,
  } = useGet({
    url: "petty-cash/currency_list",
    initialData: initialFilters,
  });

  const filtersRef = useRef(filters);
  filtersRef.current = filters;

  const debouncedSearch = useRef(
    debounce((value) => {
      const updated = { ...filtersRef.current, search_query: value, page_number: 0 };
      setFilters(updated);
    }, 300)
  ).current;

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchQuery(value);
    debouncedSearch(value);
  };

  const handlePageClick = (val) => {
    const updated = { ...filters, page_number: val.selected };
    setFilters(updated);
  };

  const { handleAuth: createCurrencyMutation } = usePut({
    url: "petty-cash/create_currency",
    refreshUrl: ["petty-cash/currency_list"],
    onSuccess: () => {
      toast.success("Currency created successfully");
    },
    onError: (err) => {
      toast.error(err?.response?.data?.message || "Failed to create currency");
    },
  });
  const { mutate: createCurrency, isLoading: isCreating } = createCurrencyMutation;

  const { handleAuth: updateCurrencyMutation } = usePut({
    url: "petty-cash/update_currency",
    refreshUrl: ["petty-cash/currency_list"],
    onSuccess: () => {
      toast.success("Currency updated successfully");
    },
    onError: (err) => {
      toast.error(err?.response?.data?.message || "Failed to update currency");
    },
  });
  const { mutate: updateCurrency, isLoading: isUpdating } = updateCurrencyMutation;

  const { handleAuth: deleteCurrencyMutation } = usePut({
    url: "petty-cash/delete_currency",
    refreshUrl: ["petty-cash/currency_list"],
    onSuccess: () => {
      toast.success("Currency deleted successfully");
    },
    onError: (err) => {
      toast.error(err?.response?.data?.message || "Failed to delete currency");
    },
  });
  const { mutate: deleteCurrency, isLoading: isDeleting } = deleteCurrencyMutation;

  const {
    list: singleCurrency,
    setGetListParams: setViewCurrencyParams,
  } = useGet({
    url: "petty-cash/view_currency",
    initialData: { currency_type_id: selectedCurrencyId },
    enabled: !!selectedCurrencyId,
  });

  const handleViewDetails = (currencyId) => {
    setSelectedCurrencyId(currencyId);
    setViewCurrencyParams({ currency_type_id: currencyId });
  };

  return {
    currencyList,
    filters,
    searchQuery,
    isCreating,
    isUpdating,
    isDeleting,
    singleCurrency,
    selectedCurrencyId,
    setSelectedCurrencyId,
    handleSearchChange,
    handlePageClick,
    handleViewDetails,
    createCurrency,
    updateCurrency,
    deleteCurrency,
  };
};
